import * as base64 from '../../../util/base64';

import { CallStatus } from '../../enums';
import { LoggerService } from '../../services/logger/Logger.service';
import { setCallStatus } from '../../util/error-handling/StatusByCallHelpers';

import type { AppState } from './types';
import { AppCall, UserPreferencesData } from './types';

const logger = LoggerService.getLogger();

export function setAppCallStatus(call: AppCall, status: CallStatus, state: AppState, errorCode?: number) {
  setCallStatus(call, AppCall[call], status, state.statusByCall, errorCode);
}

export const isUserPreferencesResolved = (state: AppState): boolean => {
  const callState = state.statusByCall[AppCall.getUserPreferencesData];

  if (!callState) {
    return false;
  }

  if (callState.status === CallStatus.READY) {
    return true;
  }

  return callState.status === CallStatus.ERROR && callState.errorCode === 404;
};

export const createBffLogoutUrl =(logoutUrl: string, returnUrl: string): string => {
  try {
    const url = new URL(logoutUrl);
    url.searchParams.set('returnUrl', returnUrl);

    return url.toString();
  } catch (error) {
    logger.warn('can not build the BFF logout url! error:', error);
    return returnUrl;
  }
};

export const encodeUserPreferencesData = (data: string): UserPreferencesData => {
  try {
    return (JSON.parse(base64.decode(data)) ?? {}) as UserPreferencesData;
  } catch (error) {
    logger.warn('can not parse response to json! error:', error);
    return {} as UserPreferencesData;
  }
};
